<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="(val) => emit('update:modelValue', val)"
    max-width="400"
  >
    <v-card>
      <v-card-title>ディスプレイネームを変更</v-card-title>
      <v-card-text>
        <p class="mb-3 text-caption">
          ここで設定した名前は、ルームを共有したときに相手に表示されます
        </p>
        <v-text-field
          v-model="newName"
          label="新しい名前"
          variant="outlined"
          autofocus
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="emit('update:modelValue', false)">キャンセル</v-btn>
        <v-btn color="primary" @click="saveName">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from "vue";
import { updateProfile } from "firebase/auth";
import { useAuthStore } from "@/stores/authStore";
import { postAuthWithToken } from "@/api/authApi";

const props = defineProps({
  modelValue: Boolean,
  currentName: String,
});
const emit = defineEmits(["update:modelValue"]);

const authStore = useAuthStore();
const newName = ref(props.currentName || "");

const saveName = async () => {
  try {
    const authUser = authStore.user;
    await updateProfile(authUser, {
      displayName: newName.value,
    });
    // 更新後に Vue 側の user を手動で上書き
    authUser.displayName = newName.value;
    authStore.user = authUser;
    // ✅ Djangoの /api/register に display_name を含めてPOST
    await postAuthWithToken(authUser, "/register/", newName.value);
    emit("update:modelValue", false);
  } catch (err) {
    console.error("❌ 名前の更新失敗", err);
    alert("名前の保存に失敗しました");
  }
};
</script>
